export default __webpack_public_path__ + "static/media/image-train.caba9a98.png";